// Persisted message snapshots provide history; conversation.drafts is authoritative.
// Never turn a historical snapshot into an actionable draft.
export function conversationCards(conversation, messages) {
  const drafts=conversation?.drafts || [];
  const current=new Map(drafts.map(d=>[d.id,d]));
  const anchors=new Map();
  const previous=new Map();
  messages.forEach(m=>{
    const saved=m.output?.draft, latest=saved&&current.get(saved.id);
    if(!saved||!latest)return;
    if(saved.revision===latest.revision)anchors.set(saved.id,m.id);
    else if(saved.revision<latest.revision&&saved.preview){
      const old=previous.get(saved.id);
      if(!old||old.revision<saved.revision)previous.set(saved.id,saved);
    }
  });
  const byMessage=new Map();
  messages.forEach(m=>{
    const saved=m.output?.draft;
    if(!saved)return;
    const latest=current.get(saved.id);
    if(latest&&anchors.get(saved.id)===m.id){
      byMessage.set(m.id,{draft:latest,previous:previous.get(saved.id),current:true});
    }else if(saved.preview){
      byMessage.set(m.id,{draft:saved,current:false});
    }
  });
  return {byMessage,trailing:drafts.filter(d=>!anchors.has(d.id)).map(d=>({draft:d,previous:previous.get(d.id),current:true}))};
}
